import React from 'react';
import styled from 'styled-components';

import directIllustration from './direct_illustration.svg';

const StyledWrapper = styled.div`
  display: flex;
`;

const StyledContent = styled.div`
  margin-left: ${props => props.theme.spacing[2]};
  width: 60%;
`;

const DirectDescription = () => (
  <StyledWrapper>
    <div>
      <img src={directIllustration} alt="Direct job" />
    </div>
    <StyledContent>
      <h6>Direct</h6>
      <p>The Weploy algorithm matches you with a qualified Weployee.</p>
      <p>
        Hire many Weployees at once<br />
        Ramp up your team quickly<br />
        Instantly match with vetted talent
      </p>
    </StyledContent>
  </StyledWrapper>
);

export default DirectDescription;
